var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Default Service Image",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrench",
    "data-name": "Wrench"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.937,39.099C7.377,39.659,6.573,40,5.746,40s-1.631-0.341-2.215-0.901l-2.581-2.63c-0.584-0.56-0.925-1.363-0.925-2.191             c0-0.828,0.341-1.632,0.925-2.215l16.579-16.58c1.266,3.189,3.822,5.746,7.012,7.012L7.937,39.099z M7.304,31.162             c-0.852,0-1.558,0.706-1.558,1.558s0.706,1.558,1.558,1.558s1.558-0.706,1.558-1.558S8.156,31.162,7.304,31.162z M39.416,14.486             c-1.534,4.334-5.697,7.328-10.298,7.328c-6.014,0-10.908-4.893-10.908-10.907S23.104,0,29.118,0c1.776,0,4.09,0.536,5.574,1.534             c0.244,0.17,0.39,0.39,0.39,0.682c0,0.268-0.17,0.536-0.39,0.682l-7.134,4.114v5.453l4.699,2.605             c0.804-0.463,6.452-4.017,6.939-4.017c0.487,0,0.78,0.365,0.78,0.852C39.976,12.708,39.683,13.707,39.416,14.486z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.cd26763a.svg";
export { ForwardRef as ReactComponent };